package com.kinoshazam.uiKit.components.genreItem

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.image.ImageUiKitState
import com.kinoshazam.uiKit.components.image.UiKitImage
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.BoldLarge
import com.kinoshazam.uiKit.theme.UiKitTheme

@Composable
fun MediumGenreItem(
    state: GenreItemState,
    modifier: Modifier = Modifier,
    isFocused: Boolean = false,
    onAction: () -> Unit = {},
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()
    val highlightTitle = isHovered || isFocused

    Box(
        modifier = modifier
            .requiredSize(160.dp, 118.dp)
            .clickable(
                interactionSource = interactionSource,
                indication = null,
                onClick = onAction,
            )
    ) {
        val borderColor =
            if (isFocused) UiKitTheme.colors.color_1 else UiKitTheme.colors.color_4

        Box(
            modifier = Modifier
                .align(Alignment.TopCenter)
                .size(100.dp)
                .border(
                    border = BorderStroke(4.dp, borderColor),
                    shape = RoundedCornerShape(50.dp)
                )
        )

        Box(
            modifier = Modifier
                .align(Alignment.TopCenter)
                .size(100.dp)
                .clip(shape = RoundedCornerShape(50.dp))
                .background(
                    brush = Brush.verticalGradient(
                        0.7f to UiKitTheme.colors.color_3.copy(alpha = 0.0f),
                        1.0f to UiKitTheme.colors.color_3,
                        endY = 180.0f
                    )
                )

        ) {
            UiKitImage(
                state = ImageUiKitState(
                    url = null,
                    placeholder = state.icon,
                    contentScale = ContentScale.Crop,
                ),
                modifier = Modifier.size(42.dp, 42.dp).align(Alignment.Center)
            )
        }

        TextLabel(
            state = TextLabelState(
                text = state.title,
                textStyle = BoldLarge,
                color = if (highlightTitle) UiKitTheme.colors.color_1 else UiKitTheme.colors.color_2
            ),
            modifier = Modifier
                .align(Alignment.BottomCenter)
                .padding(bottom = 12.dp)
        )
    }
}
